module.exports = __webpack_public_path__ + "static/media/1-2-mobile.ccbb4f15.webp";